/* global Office */

import dayjs, { Dayjs } from "dayjs";
import relativeTime from "dayjs/plugin/relativeTime";
import { getGlobal } from "../shared/global";
import { QUERY_CLIENT } from "../shared/query-client";

dayjs.extend(relativeTime);

const g = getGlobal();

// The add-in command functions need to be available in global scope
g.refreshDataEvent = refreshDataEvent;

export function getRefreshTarget(): RefreshTarget {
  if (g.refreshTarget === undefined) {
    g.refreshTarget = new RefreshTarget();
  }
  return g.refreshTarget;
}

async function refreshDataEvent(event: Office.AddinCommands.Event) {
  await refreshData();
  event.completed();
}

export async function refreshData() {
  await QUERY_CLIENT.invalidateQueries();
}

class RefreshTarget extends EventTarget {
  emitRefreshEvent(date: Dayjs) {
    this.dispatchEvent(new CustomEvent("refresh", { detail: date }));
  }
}
